module.exports = __webpack_public_path__ + "static/white2-c42f829bf077400cb93019c117ac041e.png";